import { Filter } from '@anytag/shared-molecules';
import { useFacebookPageInfluencersContext } from '../FacebookPageInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const FacebookPageInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useFacebookPageInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
